import React, { useEffect, useState } from 'react';
import { Button, Card, Col, Alert, Form, Row, Spinner } from 'react-bootstrap';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { updateBannerOneInfoCard } from '../../../Common/data/updateBannerOneInfoCard';
import { getBannerOneInfoCard, BannerOneInfoCard as BannerOneData } from '../../../Common/data/bannerOneInfoCard';

const BannerOneInfoCard = () => {
    const [formData, setFormData] = useState({
        updatedBy: 'Admin',
        pageStatus: '2',
        pageID: '5f2ac32f-af7b-4bb2-a88d-c49814c24e77',
        pageName: '',
        pageContent: '',
    });
    const [successAlert, setSuccessAlert] = useState(false);
    const [bannerOneData, setBannerOneData] = useState<BannerOneData | undefined>(undefined);
    const [processing, setProcessing] = useState(false);
    const [error, setError] = useState('');

    const handleSubmit = async (e: React.FormEvent<HTMLButtonElement>) => {
        e.preventDefault();

        setProcessing(true);
        setError('');

        try {
            const updatedData = {
                ...formData,
                pageName: getElementValue('banner-title-input'),
                pageContent: formData.pageContent,
            };

            console.log('Updated BannerOne Info Data:', updatedData);

            await updateBannerOneInfoCard(updatedData);

            console.log('BannerOne Info updated successfully!');
            setSuccessAlert(true);

            // Hide the success alert after 3 seconds
            setTimeout(() => {
                setSuccessAlert(false);
            }, 3000);
        } catch (error: any) {
            console.error('Error updating BannerOne Info:', error.message);
        } finally {
            setProcessing(false);
        }
    };

    const getElementValue = (elementId: string): string => {
        const element = document.getElementById(elementId);

        if (element && 'value' in element) {
            return element.value as string;
        }

        return '';
    };

    const fetchBannerOneDetails = async () => {
        try {
            const data = await getBannerOneInfoCard();
            setBannerOneData(data);
        } catch (error: any) {
            console.error('Error fetching Banner One Info Card details:', error.message);
        }
    };

    useEffect(() => {
        // Fetch banner one details when the component mounts
        fetchBannerOneDetails();
    }, []); // Empty dependency array ensures the effect runs only once

    return (
        <Card>
            <Card.Header>
                <div className="d-flex">
                    <div className="flex-shrink-0 me-3">
                        <div className="avatar-sm">
                            <div className="avatar-title rounded-circle custom-bg-light custom-text-primary fs-20">
                                <i className="bi bi-box-seam"></i>
                            </div>
                        </div>
                    </div>
                    <div className="flex-grow-1">
                        <h5 className="card-title mb-1">Banner One Information</h5>
                        <p className="text-muted mb-0">Fill in all information below.</p>
                    </div>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col lg={6}>
                        <div className="mb-3">
                            <Form.Label htmlFor="banner-title-input">Title</Form.Label>
                            <Form.Control
                                type="text"
                                id="banner-title-input"
                                defaultValue={bannerOneData?.pageName}
                                placeholder="Enter a title"
                                required
                                onChange={(e) => setFormData({ ...formData, pageName: e.target.value })}
                            />
                            <div className="invalid-feedback">Please enter a title.</div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div className="mb-3">
                            <Form.Label htmlFor="banner-content-input">Content</Form.Label>
                            <CKEditor
                                editor={ClassicEditor}
                                data={bannerOneData?.pageContent || ''}
                                onReady={(editor: any) => {
                                    // You can store the "editor" and use it when needed.
                                }}
                                onChange={(event: React.ChangeEvent<HTMLInputElement>, editor: any) => {
                                    if (editor) {
                                        const content: string = editor.getData();
                                        setFormData({ ...formData, pageContent: content });
                                    }
                                }}
                            />
                            <div className="invalid-feedback">Please enter content.</div>
                        </div>
                    </Col>
                </Row>

                {error && <Alert variant="danger">{error}</Alert>}
                {successAlert && (
                    <Alert variant="success" onClose={() => setSuccessAlert(false)} dismissible>
                        <p>BannerOne Info updated successfully!</p>
                    </Alert>
                )}
                <Button type="submit" variant="primary" onClick={handleSubmit}>
                    {processing ? <Spinner animation="border" size="sm" /> : 'Save Changes'}
                </Button>
            </Card.Body>
        </Card>
    );
};

export default BannerOneInfoCard;
